import { render, staticRenderFns } from "./ChartKLine2.vue?vue&type=template&id=254247d8&scoped=true"
import script from "./ChartKLine2.vue?vue&type=script&lang=js"
export * from "./ChartKLine2.vue?vue&type=script&lang=js"
import style0 from "./ChartKLine2.vue?vue&type=style&index=0&id=254247d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254247d8",
  null
  
)

export default component.exports